<template>
  <component
    :is="component"
    v-model="selected"
    v-bind="$attrs"
    :items="items"
    :clearable="clearable"
    v-on="$listeners"
    @click:clear="$emit('clearClick')"
  >
    <template
      v-for="(_, name) in $scopedSlots"
      :slot="name"
      slot-scope="slotData"
    >
      <slot
        :name="name"
        v-bind="slotData"
      />
    </template>
  </component>
</template>

<script>
import { VSelect, VAutocomplete, VCombobox } from 'vuetify/lib';

export default {
  name: 'SingleSelect',
  inheritAttrs: true,
  props: {
    searchable: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number, Boolean],
      default: undefined,
    },
    items: {
      type: Array,
      default: () => [],
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: this.value,
    };
  },
  computed: {
    color() {
      return this.selected.length > 0 ? 'primary darken-2' : '';
    },
    component() {
      if (this.$parent.$options.name === 'CategoryFilter') {
        return VCombobox;
      }
      return this.searchable ? VAutocomplete : VSelect;
    },
  },
  watch: {
    value(value) {
      this.selected = value;
    },
  },
};
</script>

<style lang="scss">
  .v-chip__content {
    color: var(--toolbar-color);
  }
</style>
